<template>
  <div>
    <div class="title-h3 title-bar">구성 정보</div>
    <hr class="mr-b20" />
    <el-row v-loading="isLoading" type="flex" justify="space-between" :gutter="20" class="mr-t5">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="spanInteger">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기본 정보</div>
              <div class="list form-list">
                <el-form ref="configForm" :model="formData" label-width="120px" :rules="configRules">
                  <el-form-item label="E2E 서비스명">
                    <w-text-form :modifiable="modifiable" :target="formData" property="serviceName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="프로토콜">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="protocolList" option-key="basicinfoSubid" property="basicinfoSubid" labelprop="basicinfoSubname"> </w-select-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">에이전트 정보</div>
              <div class="list form-list">
                <el-form ref="agentForm" :model="formData" label-width="120px">
                  <el-form-item v-for="field in agentInfo" :key="field.id" :label="field.label">
                    <span class="h100 w100"> {{ getValueAfterCheckEmpty(field.value) }} </span>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="spanInteger" v-if="isHTTP || isFTP || isSMTP || isPOP">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">프로토콜 세부 정보</div>
              <div v-if="isHTTP" class="list form-list" key="http-form">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="수집방식">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="methodList" option-key="method" property="method" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="URL">
                    <w-text-form :modifiable="modifiable" :target="formData" property="httpUrl"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="파라미터">
                    <w-text-form :modifiable="modifiable" :target="formData" property="httpParam"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="문자열 정합성 사용유무">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="adjustStrTypeList" option-key="httpAdjustType" property="httpAdjustType" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="정합성 문자열">
                    <w-text-form :modifiable="httpAdjustTypeUse" :target="formData" property="httpAdjustText"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="DB 선택">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="dbList" option-key="dbSettingId" property="dbSettingId" labelprop="dbSettingName"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="SQL">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dbSql"> </w-text-form>
                  </el-form-item>
                  <el-form-item v-if="isHTTPS" label="HTTPS 인증서 사용유무">
                    <w-check-form :modifiable="modifiable" :target="formData" property="httpsCertificateUseFlag" tfType="Number"> </w-check-form>
                  </el-form-item>
                  <el-form-item v-if="isHTTPS" label="HTTPS 인증서 이름">
                    <w-text-form :modifiable="httpsCertificateUse" :target="formData" property="httpsCertificateName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="중요도">
                    <w-obj-importance-form-editor :modifiable="modifiable" :target="formData" property="objImportance"> </w-obj-importance-form-editor>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="isFTP" class="list form-list" key="ftp-form">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="URL">
                    <w-text-form :modifiable="modifiable" :target="formData" property="ftpUrl"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="아이디 ">
                    <w-text-form :modifiable="modifiable" :target="formData" property="ftpId"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="패스워드">
                    <w-text-form :modifiable="modifiable" :target="formData" property="ftpPw" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="파일전송 여부">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="ftpTestTypeList" option-key="ftpTestType" property="ftpTestType" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="파일이름">
                    <w-text-form :modifiable="ftpTestTypeUse" :target="formData" property="ftpFileName"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="isSMTP" class="list form-list" key="smtp-form">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="메일 아이디">
                    <w-text-form :modifiable="modifiable" :target="formData" property="mailerId"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="메일 패스워드">
                    <w-text-form :modifiable="modifiable" :target="formData" property="mailerPw" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="URL">
                    <w-text-form :modifiable="modifiable" :target="formData" property="smtpUrl"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="암호방식">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="smptCiperTypeList" option-key="smtpCipherType" property="smtpCipherType" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="메일전송 유무">
                    <w-check-form :modifiable="modifiable" :target="formData" property="smtpSenderApplyFlag" tfType="Number"> </w-check-form>
                  </el-form-item>
                  <el-form-item label="보내는 사람">
                    <w-text-form :modifiable="modifiable" :target="formData" property="smtpSenderId"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="받는 사람">
                    <w-text-form :modifiable="modifiable" :target="formData" property="smtpReceiverId"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="참조">
                    <w-text-form :modifiable="modifiable" :target="formData" property="smtpCcId"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="메일내용">
                    <w-text-form :modifiable="modifiable" :target="formData" property="smtpContext" type="textarea"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="isPOP" class="list form-list" key="pop-form">
                <el-form v-if="isPOP" :model="formData" label-width="120px">
                  <el-form-item label="POP URL">
                    <w-text-form :modifiable="modifiable" :target="formData" property="popUrl"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="SSL 사용유무">
                    <w-check-form :modifiable="modifiable" :target="formData" property="popSslUseFlag" tfType="Number"> </w-check-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="spanInteger">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">관리자/유지보수 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="관리자(정)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMajor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMajor) }} </span>
                  </el-form-item>
                  <el-form-item label="관리자(부)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMinor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMinor) }} </span>
                  </el-form-item>
                  <el-form-item label="유지보수 업체">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceCompany"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 담당자">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceManager"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 연락처">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceTel"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">Application Link 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="Link">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkWwwUrl"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Application">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkAppPath"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">이벤트 제외 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="이벤트 제외">
                    <w-check-form :modifiable="modifiable" :target="formData" property="eventExceptFlag"> </w-check-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, isUndefined, isNil, eq, assign, has } from 'lodash';
import e2eInfoAPI from '@/api/config/e2e/e2e-info';
import commonAPI from '@/api/config/common';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import MsgUtil from '@/utils/message';

// for edit cmp
import WTextForm from '@/components/formeditor/TextFormEditor';
import WNumberForm from '@/components/formeditor/NumberFormEditor';
import WSelectForm from '@/components/formeditor/SelectFormEditor';
import WCheckgroupForm from '@/components/formeditor/CheckGroupFormEditor';
import WCheckForm from '@/components/formeditor/CheckFormEditor';
import wManagerTreeForm from '@/components/formeditor/MgrTreeSelectEditor';
import WObjImportanceFormEditor from '@/components/formeditor/ObjImportanceFormEditor';

const methodList = [
  {
    label: 'GET',
    method: 'GET',
  },
  {
    label: 'POST',
    method: 'POST',
  },
];
const adjustStrTypeList = [
  {
    httpAdjustType: 'N',
    label: '사용안함',
  },
  {
    httpAdjustType: 'G',
    label: '해당 문자열이 있어야함',
  },
  {
    httpAdjustType: 'B',
    label: '해당 문자열이 있으면 안됨',
  },
];

const ftpTestTypeList = [
  {
    ftpTestType: 'N',
    label: '사용안함',
  },
  {
    ftpTestType: 'U',
    label: '업로드',
  },
  {
    ftpTestType: 'D',
    label: '다운로드',
  },
];

export default {
  name: 'WConfigStatus',
  props: {
    nodeParams: Object,
  },
  components: {
    e2eInfoAPI,
    WTextForm,
    WNumberForm,
    WSelectForm,
    WCheckgroupForm,
    WCheckForm,
    wManagerTreeForm,
    WObjImportanceFormEditor,
  },
  data() {
    return {
      isLoading: true,
      spanInteger: 8,
      false: false,
      // Reject데이터
      objOriginData: {},
      formData: {
        basicinfoSubid: null,
      },
      agentInfo: [],
      adjustStrTypeList,
      methodList,
      ftpTestTypeList,
      managerList: [],
      protocolList: [],
      dbList: [],
      smptCiperTypeList: [],
      basicDataLoadFlag: false,
    };
  },
  computed: {
    ...mapGetters(['configRules', 'rejectConfigEditing', 'saveConfigEditing']),
    params() {
      return {
        serviceId: this.nodeParams.serviceId,
        transactionId: this.nodeParams.transactionId,
      };
    },
    modifiable() {
      return this.$store.state.config.isConfigEditing;
    },
    httpAdjustTypeUse() {
      return isNil(this.formData.httpAdjustType) || !eq('N', this.formData.httpAdjustType) ? this.modifiable : this.false;
    },
    httpsCertificateUse() {
      return isNil(this.formData.httpsCertificateUseFlag) || eq('1', this.formData.httpsCertificateUseFlag) ? this.modifiable : this.false;
    },
    ftpTestTypeUse() {
      return isNil(this.formData.ftpTestType) || !eq('N', this.formData.ftpTestType) ? this.modifiable : this.false;
    },
    isHTTP() {
      return isNil(this.formData.basicinfoSubid) || eq('HTTP', this.formData.basicinfoSubid) || eq('HTTPS', this.formData.basicinfoSubid);
    },
    isHTTPS() {
      return eq('HTTPS', this.formData.basicinfoSubid);
    },
    isFTP() {
      return eq('FTP', this.formData.basicinfoSubid);
    },
    isSMTP() {
      return eq('SMTP', this.formData.basicinfoSubid);
    },
    isPOP() {
      return eq('POP', this.formData.basicinfoSubid);
    },
    originProtocol() {
      return isNil(this.objOriginData) ? null : this.objOriginData.protocol;
    },
  },
  watch: {
    params: {
      immediate: true,
      handler() {
        if (this.modifiable) {
          // 대상 변경 시 수정모드 종료
          this.$store.dispatch('setConfigEditing', false);
        }
        this.loadData();
      },
    },
    rejectConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.formData = Object.assign({}, this.objOriginData);
          this.$store.dispatch('initRejectConfig');
        }
      },
    },
    saveConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.$refs.configForm.validate((valid) => {
            if (valid) {
              this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.SAVE))
                .then(() => {
                  const formData = this.formData;
                  const infoParams = Object.assign({}, formData);
                  const modifiedData = formData.modified;
                  const updateDate = {
                    serviceId: infoParams.serviceId,
                    transactionId: infoParams.transactionId,
                    objCompanyId: infoParams.objCompanyId,
                    objImportance: formData.objImportance, // null이면 delete로 판단하므로 값 변경이 없을 경우에도 서버단에 전달한다.
                  };
                  // 수정된값들
                  if (modifiedData && Object.keys(modifiedData).length > 0) {
                    Object.keys(modifiedData).forEach((key) => {
                      if (key === 'basicinfoSubid') {
                        updateDate.protocol = formData.basicinfoSubid;
                      } else {
                        updateDate[key] = formData[key];
                      }
                    });
                    if (!isNil(updateDate.httpAdjustType) && updateDate.httpAdjustType === 'N' && !isNil(formData.httpAdjustText) && formData.httpAdjustText !== '') {
                      updateDate.httpAdjustText = '';
                    }
                  }

                  if (this.objOriginData.objManagerIdMajor !== formData.objManagerIdMajor) {
                    updateDate.objManagerIdMajor = formData.objManagerIdMajor;
                  }

                  if (this.objOriginData.objManagerIdMinor !== formData.objManagerIdMinor) {
                    updateDate.objManagerIdMinor = formData.objManagerIdMinor;
                  }

                  // 값의 수정을 위해 꼭 있어야하는 필드
                  updateDate.serviceName = formData.serviceName;

                  const target = '구성 정보';
                  const action = MsgUtil.action.SAVE;
                  const encryptTargetData = createEncryptTargetData(updateDate, ['ftpPw', 'mailerPw']);
                  if (encryptTargetData !== null) {
                    if (has(encryptTargetData, 'ftpPw')) {
                      updateDate.ftpId = formData.ftpId;
                    }
                    if (has(encryptTargetData, 'mailerPw')) {
                      updateDate.mailerId = formData.mailerId;
                    }
                    getRsaEncrypt(encryptTargetData)
                      .then((encryptData) => {
                        this.saveConfig(assign(updateDate, encryptData), action, target);
                      })
                      .catch((e) => {
                        this.$message(MsgUtil.getResultMsgData(action, target, false));
                        throw new Error(e);
                      });
                  } else {
                    this.saveConfig(updateDate, action, target);
                  }
                })
                .catch(() => {
                  this.$store.dispatch('setSaveConfigEditing', false);
                });
            } else {
              this.$store.dispatch('setSaveConfigEditing', false);
            }
          });
        }
      },
    },
  },
  methods: {
    getValueAfterCheckEmpty,
    /**
     * managerName 조회
     * @param  {[type]} managerId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getObjManagerName(managerId) {
      if (isEmpty(managerId)) {
        return EMPTY_TEXT;
      }
      const mgrInfo = this.managerList.find((data) => data.managerId === managerId);
      return isEmpty(mgrInfo) ? EMPTY_TEXT : mgrInfo.managerName;
    },
    loadData() {
      this.isLoading = true;
      // 최초 한번만 실행
      if (!this.basicDataLoadFlag) {
        this.setBasicData();
      }
      this.objOriginData = {};
      if (!isUndefined(this.nodeParams.serviceId) && !isUndefined(this.nodeParams.transactionId)) {
        e2eInfoAPI.getE2eConfigInfoBasic(this.params).then((result) => {
          if (result.data.success) {
            const data = result.data.data;

            if (!isNil(data.protocol)) {
              data.basicinfoSubid = data.protocol;
            }

            if (!isNil(data.agentList) && data.agentList.length > 0) {
              const agentInfo = [];

              data.agentList.forEach((field) => {
                agentInfo.push({
                  id: field.agentId,
                  label: field.agentName,
                  value: field.agentIpaddress,
                });
              });

              this.agentInfo = agentInfo;
            }

            Object.assign(this.objOriginData, data);
            this.formData = Object.assign({}, this.objOriginData);

            if (!this.isHTTP && !this.isFTP && !this.isSMTP && !this.isPOP) {
              this.spanInteger = 12;
            } else {
              this.spanInteger = 8;
            }
            this.$emit('setConfigData', this.formData);
          }
        });
      }
      this.isLoading = false;
    },
    /**
     * 구성 정보를 저장한다.
     * @author Ju
     * @param  {[type]} params [description]
     * @param  {[type]} action [description]
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    saveConfig(params, action, target) {
      e2eInfoAPI
        .updateE2eObjConfig(params)
        .then((result) => {
          if (result.data.success) {
            this.$message(MsgUtil.getResultMsgData(action, target, true));
            this.$store.dispatch('endConfigEdit');
            this.loadData();
          } else {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(action, target, true));
        });
    },
    setBasicData() {
      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'E2E_PROTOCOL',
        })
        .then((res) => {
          this.protocolList = res.data.data;
        });

      e2eInfoAPI.getDbList({}).then((res) => {
        this.dbList = res.data.data;
      });

      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SMTP_CIPER_TYPE',
        })
        .then((res) => {
          const list = res.data.data;
          const smptCiperTypeList = [];

          list.forEach((data) => {
            smptCiperTypeList.push({
              label: data.basicinfoSubname,
              smtpCipherType: data.basicinfoSubid,
            });
          });
          this.smptCiperTypeList = smptCiperTypeList;
        });
      commonAPI.getMgrInfoList({}).then((res) => {
        this.managerList = res.data.data;
      });
      this.basicDataLoadFlag = true;
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}

.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: #8b8b8b;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/e2e/configstatus/index.vue